import FaxPage from './Fax.page';

export default FaxPage;
